import { render, staticRenderFns } from "./CriticalPositionDesignation.vue?vue&type=template&id=02a765bc&scoped=true"
import script from "./CriticalPositionDesignation.vue?vue&type=script&lang=js"
export * from "./CriticalPositionDesignation.vue?vue&type=script&lang=js"
import style0 from "./CriticalPositionDesignation.vue?vue&type=style&index=0&id=02a765bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a765bc",
  null
  
)

export default component.exports